import React from 'react';
import classNames from 'classnames';

export default function BeachIcon({ className = '' }) {
	return <span className={classNames('icon icon-beach', className)} />;
}
